import { motion, useReducedMotion } from 'framer-motion';

const COLORS = ['#ff3d7f', '#ff9f1c', '#00e5ff', '#a3ff3d', '#b14dff', '#ffcf3d', '#00f5d4'];

// A short burst of particles from the center of its parent.
export default function Confetti({ count = 26 }) {
  const reduce = useReducedMotion();
  if (reduce) return null;
  return (
    <span className="confetti" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => {
        const angle = (i / count) * Math.PI * 2;
        const dist = 70 + ((i * 37) % 60);
        return (
          <motion.i
            key={i}
            style={{ background: COLORS[i % COLORS.length] }}
            initial={{ x: 0, y: 0, opacity: 1, scale: 1, rotate: 0 }}
            animate={{ x: Math.cos(angle) * dist, y: Math.sin(angle) * dist + 30, opacity: 0, scale: 0.6, rotate: 220 }}
            transition={{ duration: 0.9 + (i % 4) * 0.1, ease: 'easeOut' }}
          />
        );
      })}
    </span>
  );
}
